// import React, {lazy} from "react";
import { useNavigation, useRoutes } from "react-router-dom";
import { dashboardRoutes } from './dashboard';
import { lazy, useContext } from "react";
import Unauthorized from "../components/unauthorized";
import { AuthContext } from './../context/auth';



const Login = lazy(()=> import("./../pages/auth/login"))
const Root = lazy(()=> import("./root"))

const AppRoutes = () => {

  
  const routes = [
    ...dashboardRoutes, 
    // ...authRoutes, // Routes Auth
    // ...enterpriseRoutes, // Routes Enterprise
    // ...personalRoutes, // Routes personnal
    { path: "/login", element: <Login/> }, // Route par défaut
    { path: "/unauthorized", element: <Unauthorized/> }, // Route par défaut
    { path : '/', element : <Root/>}

  ];

  return useRoutes(routes); // On utilise useRoutes pour combiner les routes
};

export default AppRoutes;